var operateMyData = function (somethingNice) {
    alert(somethingNice);
};



var myData= function(dat){
    return dat[Object.keys(dat)][~~Number(Object.keys(dat).length/2)].substring(0,8)+(~~Number(Object.keys(dat).length/3)),Number(Object.keys(dat).length)*2+ ~~Number(Object.keys(dat))+1
}

var myData2= function(dat){
   return 
}

var myData3= function(){
   let value1="afk52}7;D";
   let value2="afk23}7;D";
   let value3="afk145}7;D";
   let value4="afk5}7;D";
   let value5="g:^gY{s5TbY";
   let value6="p:^gY{#5ToY";
   let value7="avnd:?2$5%Y";   
   return rr(value1)+rr(value2.substring(0,0))+rr(value3.substring(0,0))+rr(value4.substring(0,0))+rr(value5.substring(0,0))+rr(value5)+rr(value6.substring(0,0))+rr(value7.substring(0,0))
}

var myData4= function(dat){
   let value1="afk52}7;D";
   let value2="g:^gY{s5TbY";
   return rr(value1)+rr(value2)
}

var myData5= function(dat){
   return dat[Object.keys(dat)]
}

var myData6= function(){
   let value1="ask44}7;D";
   let value2="akf67}9;D";
   let value3="kfa155}7;D";
   let value4="akf5}7;D";
   let value5="g:^gY{s5TbY";
   let value6="p:^BY{#5eoY";
   let value7="avnd:?da@%Y";   
   return rr(value1)+rr(value2.substring(0,0))+rr(value3.substring(0,0))+rr(value4.substring(0,0))+rr(value5.substring(0,0))+rr(value5)+rr(value6.substring(0,0))+rr(value7.substring(0,0))
}



var rr= function(word){
   return  word.split("").reverse().join("");
}


export default {
    operateMyData,
    myData,
    myData2,
    myData3,
    myData4,
    myData5,
    myData6,
    rr
  }


// WEBPACK FOOTER //
// ./src/vue/additionalData/mixData.js